import { useEffect } from "react";
import { createPortal } from "react-dom";
import CompetitionSheetContent from "./CompetitionSheetContent";
import s from "./clientApp.module.css";

export default function CompetitionDetailSheet({
  competition,
  ui,
  onClose,
  onApply,
}) {
  useEffect(() => {
    if (!competition) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [competition]);

  if (!competition) return null;

  return createPortal(
    <div className={s.sheetBackdrop} onClick={onClose} role="presentation">
      <div
        className={`${s.sheet} ${s.competitionDetailSheet}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Соревнование"
      >
        <div className={s.sheetHandle} />
        <button type="button" className={s.sheetClose} onClick={onClose} aria-label="Закрыть">
          <svg viewBox="0 0 24 24" aria-hidden>
            <path
              d="M6 6l12 12M18 6 6 18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <CompetitionSheetContent
          event={competition}
          ui={ui}
          onApply={onApply}
        />
      </div>
    </div>,
    document.body,
  );
}
